// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationsForm_muteNotSelected__TpQ85 {
  background: white;
  color: black;
  border-radius: 4px;
  border: 2px solid var(--branded-purple);
}

.NotificationsForm_NavButton__E\\+s9h {
  cursor: pointer;
  background: none;
  border: 0px;
  color: white;
}

.NotificationsForm_addSpace__AlkHc {
  margin-bottom: 10px;
}

.NotificationsForm_addLargeSpace__T23eV {
  margin-bottom: 30px;
}

.NotificationsForm_NoteMarkRead__jB2JK {
  float: right;
}

.p-accordion-header:not(.p-disabled) a {
  height: auto !important;
}

.NotificationsForm_noteAccordion__QxaVM {
  width: 100%;
  margin-bottom: 10px;

  .p-accordion-content {
    padding-left: 2rem;
  }

  .p-accordion-tab .p-accordion-tab-active {
    border: 1px solid var(--branded-purple-border) !important;
  }

  .p-accordion-header:not(.p-disabled) .p-accordion-header-link {
    background: white;
    border: 1px solid var(--branded-purple-border);
    border-radius: 12px;
    padding-left: 0.6rem;
  }

  .p-accordion-tab-active
        .p-accordion-header:not(.p-disabled)
        .p-accordion-header-link {
    border: none;
    border-bottom: 1px solid var(--branded-purple-border);
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    width: calc(100% - 10px);
    margin-left: 5px;
  }

  .p-accordion-tab-active
        .p-accordion-header:not(.p-disabled)
        .p-accordion-header-link
        .p-accordion-header-text {
    .NotificationsForm_noteHeaderGridItemCreation__sPUuR,
    .NotificationsForm_noteHeaderGridItemOrg__fdBXS {
      margin-right: 25px;
    }

    margin-left: -5px;
  }
}

/*Notifications acordian grid: */
.NotificationsForm_noteHeaderGridContainer__g53QW {
  display: grid;
  grid-template-areas:
    "unread title-desc other"
    "unread system-not .";
  grid-template-columns: 2rem 1fr 1fr;
  align-items: center;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
}

.NotificationsForm_unread__LLtXE {
  grid-area: unread;
  visibility: visible;
  width: 10px;
  height: 10px;
  background-color: var(--branded-purple);
  border-radius: 100%;
  margin-left: 5px;
}

.NotificationsForm_systemNot__Xhm1Y {
  width: fit-content;
  margin-top: 0.4rem;
  grid-area: system-not;
}

.NotificationsForm_noteHeaderTitleDesc__nvb1u {
  grid-area: title-desc;
}

.NotificationsForm_noteHeaderOther__\\+p7cn {
  grid-area: other;
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: flex-end;
}

.NotificationsForm_noteHeaderGridItemTitle__BRXrF {
  color: #383838;
  font-weight: bold;
  font-size: 1rem;
  display: flex;
  align-items: center;
}

.NotificationsForm_noteHeaderGridItemCreation__sPUuR {
  text-align: left;
  font-size: 0.75rem;
  color: #999999;
  font-weight: normal;
  margin-right: 30px;
  width: 140px;
}

.NotificationsForm_noteHeaderGridItemOrg__fdBXS {
  text-align: left;
  font-size: 0.75rem;
  color: #383838;
  margin-top: 5px;
  margin-right: 30px;
  font-weight: normal;
  width: 140px;
}

.NotificationsForm_noteHeaderGridItemDescr__uSuKB {
  color: #383838;
  font-weight: normal;
  font-size: 0.77rem;
  margin-top: 5px;
}

.NotificationsForm_systemNotification__EgNMF {
  .p-accordion-toggle-icon {
    visibility: hidden;
  }

  a {
    cursor: default !important;
    pointer-events: none !important;
  }
}

.NotificationsForm_toggleDescriptionButton__5zx3c {
  width: 100%;
  font-size: 12px;
  padding: 6px;
  margin: 8px 0px 10px 0px;
}

.NotificationsForm_allread_button__yxAro {
  background-color: #ffffff !important;
  border: 1px solid var(--branded-purple-border) !important;
  color: var(--branded-font-color) !important;
  border-radius: 4px;
  height: 40px;
  width: 150px;
}

.NotificationsForm_allread_confirm_container__YShzP {
  float: right;
  padding: 5px;
  margin-top: 25px;
}

.NotificationsForm_allread_confirm_yes__Zmv2A {
  min-width: 100px;
}

.NotificationsForm_allread_confirm_no__NF1iD {
  border: 1px solid var(--branded-purple) !important;
  border-radius: 4px;
  color: var(--branded-font-color) !important;
  background-color: #ffffff !important;
  width: 100px;
  margin-left: 5px;
}

/*Notifications accordion body grid: */
.NotificationsForm_noteBodyContainer__SpmQX {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: #383838;
  font-size: 0.75rem;
}

.NotificationsForm_noteBodyInfo__2xUeH {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-right: 15px;
}

.NotificationsForm_noteBodyActionButtons__q1Ib6 {
  display: flex;
  gap: 10px;
}

.NotificationsForm_noteBodyActionButton__tyMHt {
  display: flex;
  flex-wrap: wrap;
  min-width: 150px;
  font-size: 1rem;
}

.NotificationsForm_label__QJl0b {
  font-size: 0.75rem;
  font-weight: bold;
}

/*Notifications filters dialog: */
.NotificationsForm_filter_dialog_container__P0PWg {
  display: grid;
  grid-template-areas:
    "filter-searchBox filter-eventType"
    "filter-date-created filter-date-read"
    "filter-includes filter-includes";
  grid-template-columns: 1fr 1fr;
  row-gap: 1.4rem;
  column-gap: 0.6rem;
  width: 100%;
  padding: 0.25rem;

  .NotificationsForm_filter_includes__dnkoZ > div {
    label {
      margin-left: 5px;
      font-size: 0.89rem;
      color: var(--branded-font-color);
    }
  }

  .p-calendar {
    width: auto !important;
  }

  .NotificationsForm_label__QJl0b {
    display: block;
    margin-bottom: 0.3rem;
  }

  .NotificationsForm_filter_searchBox__dMcAG {
    grid-area: filter-searchBox;
  }

  .NotificationsForm_filter_eventType__bOlvn {
    grid-area: filter-eventType;
  }

  .NotificationsForm_filter_date_created__V-Cd6 {
    grid-area: filter-date-created;
  }

  .NotificationsForm_filter_date_read__UDFER {
    grid-area: filter-date-read;
  }

  .NotificationsForm_filter_includes__dnkoZ {
    grid-area: filter-includes;
  }
}

/*Notifications accordion grid: */
.NotificationsForm_noteFilterHeaderGridContainer__asan8 {
  display: grid;
  grid-template-areas: "title button";
  width: 100%;
}

.NotificationsForm_noteFilterHeader__KEw2I {
  grid-area: title;
  text-align: left;
  position: absolute;
  top: 35%;
}

.NotificationsForm_noteFilterButton__u8ihZ {
  grid-area: button;
}

.NotificationsForm_noteMainTabHeader__U3qWM {
  margin-right: 10px;
  height: 45px;
  width: 120px;
  align-items: center;
  text-align: center;
  vertical-align: middle;
}

.NotificationsForm_noteMainTabHeaderActive__\\+kLq5 {
  border-color: var(--branded-purple);
}

.NotificationsForm_noteHighImportant__zbIa1 {
  font-size: 11px;
  margin-left: 10px;
}

.NotificationsForm_noteSettingsLayout__hsLMj {
  width: 100%;
  height: 100%;
  margin-bottom: 1rem;
  border: 1px solid var(--branded-light-purple);
  border-radius: 20px;
  position: relative;

  .NotificationsForm_all_notifications_row__byTeM {
    background-color: var(--branded-light-purple);
  }

  .NotificationsForm_advance_settings_btn__E4Ra5 {
    margin-top: 20px;

    span {
      font-weight: bold;
    }

    margin-left: 0.8rem;
  }

  .NotificationsForm_purple_bk__mBE\\+0 {
    background-color: var(--branded-light-purple);
  }

  .NotificationsForm_noteSettingsTable__XX4Aa {
    position: relative;
    height: 100%;
    width: 100%;

    thead,
    tbody {
      display: block;
      width: 100%;
    }

    .p-datatable-tbody:not(.p-datatable-frozen-tbody) {
      height: 50vh;
      overflow-y: auto;
      padding-right: 0.6rem;
    }
  }

  .NotificationsForm_settings_table__TRog1 {
    height: 100%;
    width: 100%;

    thead,
    tbody {
      display: block;
      width: 100%;
    }

    tbody {
      overflow-y: auto;
      padding-right: 0.6rem;
    }

    tbody > tr > td {
      color: var(--branded-text-color);
      padding: 0.6rem;
    }

    tbody > tr > td:first-child {
      padding-left: 0.8rem;
    }

    thead > tr > th {
      border: 1px solid #e5e7eb;
      border-width: 0 0 1px 0;
      padding: 0.8rem 0;
      background-color: transparent;
      color: var(--branded-text-color);

      font-weight: bold;
      text-align: left;
    }

    thead > tr > th:first-child {
      padding-left: 0.8rem;
    }

    tbody > tr > td {
      width: 10vw;
    }

    thead > tr > th {
      width: 10vw;
    }

    tbody > tr > td:first-child,
    thead > tr > th:first-child {
      width: 50vw;
    }

    tbody > tr:first-child > td {
      padding-left: 0;
      padding-right: 0;
    }

    tbody > tr > td:not(:first-child) {
      padding-left: 0;
      padding-right: 0;
    }

    tbody > tr > td:first-child {
      padding-right: 0;
    }

    tbody > tr > td {
      padding-top: 0;
      padding-bottom: 0;
    }

    .NotificationsForm_settings_table_cell__AHAEw {
      display: flex;
      align-items: center;
      height: 60px;
      border: 1px solid var(--branded-light-purple);
      border-width: 0 0 1px 0;
    }

    tbody > tr > td:last-child {
      .NotificationsForm_settings_table_cell__AHAEw {
        padding-right: 0.8rem;
      }
    }
  }

  .NotificationsForm_settings_table__TRog1.NotificationsForm_full_table__RUfC2 {
    tbody {
      height: fit-content;
    }

    td:not(:first-child) .NotificationsForm_settings_table_cell__AHAEw {
      padding-left: 0.6rem;
    }

    .NotificationsForm_isAll__f10nu {
      td {
        padding-top: 0;
        padding-bottom: 0;
      }

      td .NotificationsForm_settings_table_cell__AHAEw {
        margin-top: 0.6rem;
        padding-left: 0.6rem;
      }

      td:first-child .NotificationsForm_settings_table_cell__AHAEw {
        padding-left: 0.8rem;
      }
    }
  }

  .NotificationsForm_settings_table__TRog1:not(.NotificationsForm_full_table__RUfC2) {
    .NotificationsForm_isAll__f10nu {
      td:first-child {
        padding-left: 0.8rem;
      }

      td:not(:first-child) .NotificationsForm_settings_table_cell__AHAEw {
        padding-left: 0.6rem;
      }
    }

    td:not(:first-child) .NotificationsForm_settings_table_cell__AHAEw {
      padding-left: 0.6rem;
    }
  }

  .NotificationsForm_noteSettingsCheckedColumn__4\\+tVr {
    width: 10vw;
    padding: 0.6rem !important;
  }

  .p-datatable .p-datatable-tbody > tr > td {
    border: 1px solid var(--branded-light-purple);
    color: var(--branded-text-color);
    border-width: 0 0 1px 0;
    padding: 0.6rem 0;
    font-size: 0.75rem;
  }

  .p-datatable .p-datatable-thead > tr > th {
    border: 1px solid #e5e7eb;
    border-width: 0 0 1px 0;
    padding: 0.5rem;
    background-color: transparent;
  }

  .p-datatable .p-datatable-thead > tr > th:first-child,
  .p-datatable .p-datatable-thead > tr > th:last-child {
    padding-left: 0;
  }

  .p-datatable .p-datatable-thead > tr > th {
    width: 10vw;
  }

  .p-datatable .p-datatable-thead > tr > th:first-child {
    width: 36.9vw !important;
  }

  .p-column-title {
    color: var(--branded-text-color);
    font-size: 0.75rem;
    font-weight: bold;
  }
}

.NotificationsForm_multiselectFilter__2tosl.p-multiselect .p-multiselect-label.p-placeholder {
  font-size: 0.89rem !important;
  color: #999999;
}

.NotificationsForm_filterTemplateItem__VdpgH {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.NotificationsForm_filterTemplateLabel__JxcR- {
  font-weight: 400;
  line-height: 16.34px;
  color: #495057 !important;
}

.NotificationsForm_customMessage__pL8gQ {
  .p-message-wrapper {
    border-radius: 8px;
    border: 1px solid #3b82f6;
    background: rgba(59, 130, 246, 0.2);
    padding: 0.5rem 0.8rem;
    font-size: 0.8rem;
    width: 100%;
    position: relative;
    color: #3b82f6;

    i {
      color: #3b82f6;
      font-size: 1rem;
    }
  }

  .p-message-close {
    position: absolute;
    right: 1.1rem;

    svg {
      height: 0.8rem;
    }
  }
}

.NotificationsForm_noteMarkAsUnreadReadBtn__OdC0i {
  border-radius: 20px;
  padding-bottom: 10px;
  padding-right: 14px;
  background-color: white;
  border: 1px solid #e7e0f1 !important;
  color: #495057;
  font-weight: 400;
  font-size: 0.82rem;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 0.6rem;
  cursor: pointer !important;
  pointer-events: all !important;

  &:hover {
    background-color: rgba(135, 60, 170, 0.1);
  }
}

.NotificationsForm_noteMarkAsReadBtn__HJMXz {
  border-radius: 20px;
  padding-bottom: 10px;
  padding-right: 14px;
  background-color: #873caa;
  border: 1px solid #873caa !important;
  color: white;
  font-weight: 400;
  font-size: 0.82rem;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 0.6rem;
  cursor: pointer !important;
  pointer-events: all !important;

  &:hover {
    background-color: #6d3092;
  }
}

/* ---------------------------------- */
/* Tablet */
@media (min-width: 768px) and (max-width: 1024px) {
  .NotificationsForm_filter_dialog_container__P0PWg {
    grid-template-areas:
      "filter-searchBox filter-searchBox"
      "filter-eventType filter-eventType"
      "filter-date-created filter-date-created"
      "filter-date-read filter-date-read"
      "filter-includes filter-includes";

    .p-calendar {
      width: 100% !important;
    }
  }

  .NotificationsForm_noteBodyActionButtons__q1Ib6 {
    display: block;
  }

  .NotificationsForm_noteBodyActionButton__tyMHt {
    margin-left: 20px;
    margin-bottom: 10px;
  }
}

/* Mobile */
@media (max-width: 767px) {
  .NotificationsForm_noteBodyContainer__SpmQX {
    display: flex;
    flex-wrap: wrap;
  }

  .NotificationsForm_noteBodyActionButtons__q1Ib6 {
    display: block;
    margin-top: 20px;
  }

  .NotificationsForm_noteBodyActionButton__tyMHt {
    margin-bottom: 10px;
  }

  .NotificationsForm_filters__x8Kll {
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-between; */
    gap: 1rem;
  }

  .NotificationsForm_sort__VAIb\\+ {
    margin-left: auto;
  }

  .NotificationsForm_organization_dropdown__j6wuH {
    width: 100%;
  }

  .NotificationsForm_noteHeaderGridContainer__g53QW {
    grid-template-areas:
      "unread title-desc"
      ". other"
      ". system-not";
    grid-template-columns: 2rem 1fr;
    row-gap: 0.5rem;
  }

  .NotificationsForm_noteHeaderOther__\\+p7cn {
    flex-direction: column;
    gap: 0.8rem;
    align-items: flex-start;

    button {
      width: 100%;
    }
  }

  .p-accordion-toggle-icon {
    margin-bottom: 1rem !important;
  }

  .p-accordion-header:not(.p-disabled) a {
    align-items: flex-end !important;
  }

  .NotificationsForm_noteHeaderGridItemOrg__fdBXS,
  .NotificationsForm_noteHeaderGridItemCreation__sPUuR {
    text-align: left !important;
  }

  .NotificationsForm_filter_dialog_container__P0PWg {
    grid-template-areas:
      "filter-searchBox"
      "filter-eventType"
      "filter-date-created"
      "filter-date-read"
      "filter-includes";
    grid-template-columns: 1fr;

    .p-calendar {
      width: 100% !important;
    }

    .NotificationsForm_filter_includes__dnkoZ {
      flex-direction: column;
      gap: 0.5rem !important;
      align-items: flex-start !important;
    }
  }

  .NotificationsForm_filter_date_created__V-Cd6 > div,
  .NotificationsForm_filter_date_read__UDFER > div {
    flex-direction: column;
  }

  .NotificationsForm_noteSettingsLayout__hsLMj {
    .NotificationsForm_settings_table__TRog1.NotificationsForm_full_table__RUfC2 {
      tbody {
        height: fit-content;
      }
    }
  }
}

@media (max-width: 600px) {
  .NotificationsForm_sort__VAIb\\+ {
    margin-left: 0px;
  }
}

@media (max-width: 460px) {
  .NotificationsForm_settings_table__TRog1 {
    thead > tr > th {
      font-size: 0.6rem !important;
    }
  }

  .NotificationsForm_filters_button__kiX9C {
    width: 150px;
  }

  .NotificationsForm_allread_button__yxAro {
    width: 150px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/NotificationsForm.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;;EAEnB;IACE,kBAAkB;EACpB;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,iBAAiB;IACjB,8CAA8C;IAC9C,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;;;IAKE,YAAY;IACZ,qDAAqD;IACrD,6BAA6B;IAC7B,4BAA4B;IAC5B,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;;;;IAME;;MAEE,kBAAkB;IACpB;;IAEA,iBAAiB;EACnB;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb;;yBAEuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,2CAA2C;EAC3C,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb;;;qCAGmC;EACnC,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;;EAEhB;IACE;MACE,gBAAgB;MAChB,kBAAkB;MAClB,gCAAgC;IAClC;EACF;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;;EAElB;IACE,6CAA6C;EAC/C;;EAEA;IACE,gBAAgB;;IAEhB;MACE,iBAAiB;IACnB;;IAEA,mBAAmB;EACrB;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;;IAEX;;MAEE,cAAc;MACd,WAAW;IACb;;IAEA;MACE,YAAY;MACZ,gBAAgB;MAChB,qBAAqB;IACvB;EACF;;EAEA;IACE,YAAY;IACZ,WAAW;;IAEX;;MAEE,cAAc;MACd,WAAW;IACb;;IAEA;MACE,gBAAgB;MAChB,qBAAqB;IACvB;;IAEA;MACE,gCAAgC;MAChC,eAAe;IACjB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,yBAAyB;MACzB,uBAAuB;MACvB,iBAAiB;MACjB,6BAA6B;MAC7B,gCAAgC;;MAEhC,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;IAEA;;MAEE,WAAW;IACb;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,6CAA6C;MAC7C,uBAAuB;IACzB;;IAEA;MACE;QACE,qBAAqB;MACvB;IACF;EACF;;EAEA;IACE;MACE,mBAAmB;IACrB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE;QACE,cAAc;QACd,iBAAiB;MACnB;;MAEA;QACE,kBAAkB;QAClB,oBAAoB;MACtB;;MAEA;QACE,oBAAoB;MACtB;IACF;EACF;;EAEA;IACE;MACE;QACE,oBAAoB;MACtB;;MAEA;QACE,oBAAoB;MACtB;IACF;;IAEA;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,6CAA6C;IAC7C,gCAAgC;IAChC,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;IAClB,yBAAyB;IACzB,mCAAmC;IACnC,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,cAAc;;IAEd;MACE,cAAc;MACd,eAAe;IACjB;EACF;;EAEA;IACE,kBAAkB;IAClB,aAAa;;IAEb;MACE,cAAc;IAChB;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,WAAW;EACX,0BAA0B;EAC1B,8BAA8B;;EAE9B;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,WAAW;EACX,0BAA0B;EAC1B,8BAA8B;;EAE9B;IACE,yBAAyB;EAC3B;AACF;;AAEA,uCAAuC;AACvC,WAAW;AACX;EACE;IACE;;;;;uCAKmC;;IAEnC;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,WAAW;AACX;EACE;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,oCAAoC;IACpC,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE;;;oBAGgB;IAChB,+BAA+B;IAC/B,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,uBAAuB;;IAEvB;MACE,WAAW;IACb;EACF;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE;;;;;uBAKmB;IACnB,0BAA0B;;IAE1B;MACE,sBAAsB;IACxB;;IAEA;MACE,sBAAsB;MACtB,sBAAsB;MACtB,kCAAkC;IACpC;EACF;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE;MACE;QACE,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".muteNotSelected {\n  background: white;\n  color: black;\n  border-radius: 4px;\n  border: 2px solid var(--branded-purple);\n}\n\n.NavButton {\n  cursor: pointer;\n  background: none;\n  border: 0px;\n  color: white;\n}\n\n.addSpace {\n  margin-bottom: 10px;\n}\n\n.addLargeSpace {\n  margin-bottom: 30px;\n}\n\n.NoteMarkRead {\n  float: right;\n}\n\n:global(.p-accordion-header:not(.p-disabled) a) {\n  height: auto !important;\n}\n\n.noteAccordion {\n  width: 100%;\n  margin-bottom: 10px;\n\n  :global(.p-accordion-content) {\n    padding-left: 2rem;\n  }\n\n  :global(.p-accordion-tab .p-accordion-tab-active) {\n    border: 1px solid var(--branded-purple-border) !important;\n  }\n\n  :global(.p-accordion-header:not(.p-disabled) .p-accordion-header-link) {\n    background: white;\n    border: 1px solid var(--branded-purple-border);\n    border-radius: 12px;\n    padding-left: 0.6rem;\n  }\n\n  :global(\n      .p-accordion-tab-active\n        .p-accordion-header:not(.p-disabled)\n        .p-accordion-header-link\n    ) {\n    border: none;\n    border-bottom: 1px solid var(--branded-purple-border);\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n    width: calc(100% - 10px);\n    margin-left: 5px;\n  }\n\n  :global(\n      .p-accordion-tab-active\n        .p-accordion-header:not(.p-disabled)\n        .p-accordion-header-link\n        .p-accordion-header-text\n    ) {\n    .noteHeaderGridItemCreation,\n    .noteHeaderGridItemOrg {\n      margin-right: 25px;\n    }\n\n    margin-left: -5px;\n  }\n}\n\n/*Notifications acordian grid: */\n.noteHeaderGridContainer {\n  display: grid;\n  grid-template-areas:\n    \"unread title-desc other\"\n    \"unread system-not .\";\n  grid-template-columns: 2rem 1fr 1fr;\n  align-items: center;\n  width: 100%;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.unread {\n  grid-area: unread;\n  visibility: visible;\n  width: 10px;\n  height: 10px;\n  background-color: var(--branded-purple);\n  border-radius: 100%;\n  margin-left: 5px;\n}\n\n.systemNot {\n  width: fit-content;\n  margin-top: 0.4rem;\n  grid-area: system-not;\n}\n\n.noteHeaderTitleDesc {\n  grid-area: title-desc;\n}\n\n.noteHeaderOther {\n  grid-area: other;\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.noteHeaderGridItemTitle {\n  color: #383838;\n  font-weight: bold;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n}\n\n.noteHeaderGridItemCreation {\n  text-align: left;\n  font-size: 0.75rem;\n  color: #999999;\n  font-weight: normal;\n  margin-right: 30px;\n  width: 140px;\n}\n\n.noteHeaderGridItemOrg {\n  text-align: left;\n  font-size: 0.75rem;\n  color: #383838;\n  margin-top: 5px;\n  margin-right: 30px;\n  font-weight: normal;\n  width: 140px;\n}\n\n.noteHeaderGridItemDescr {\n  color: #383838;\n  font-weight: normal;\n  font-size: 0.77rem;\n  margin-top: 5px;\n}\n\n.systemNotification {\n  :global(.p-accordion-toggle-icon) {\n    visibility: hidden;\n  }\n\n  a {\n    cursor: default !important;\n    pointer-events: none !important;\n  }\n}\n\n.toggleDescriptionButton {\n  width: 100%;\n  font-size: 12px;\n  padding: 6px;\n  margin: 8px 0px 10px 0px;\n}\n\n.allread_button {\n  background-color: #ffffff !important;\n  border: 1px solid var(--branded-purple-border) !important;\n  color: var(--branded-font-color) !important;\n  border-radius: 4px;\n  height: 40px;\n  width: 150px;\n}\n\n.allread_confirm_container {\n  float: right;\n  padding: 5px;\n  margin-top: 25px;\n}\n\n.allread_confirm_yes {\n  min-width: 100px;\n}\n\n.allread_confirm_no {\n  border: 1px solid var(--branded-purple) !important;\n  border-radius: 4px;\n  color: var(--branded-font-color) !important;\n  background-color: #ffffff !important;\n  width: 100px;\n  margin-left: 5px;\n}\n\n/*Notifications accordion body grid: */\n.noteBodyContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  color: #383838;\n  font-size: 0.75rem;\n}\n\n.noteBodyInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-right: 15px;\n}\n\n.noteBodyActionButtons {\n  display: flex;\n  gap: 10px;\n}\n\n.noteBodyActionButton {\n  display: flex;\n  flex-wrap: wrap;\n  min-width: 150px;\n  font-size: 1rem;\n}\n\n.label {\n  font-size: 0.75rem;\n  font-weight: bold;\n}\n\n/*Notifications filters dialog: */\n.filter_dialog_container {\n  display: grid;\n  grid-template-areas:\n    \"filter-searchBox filter-eventType\"\n    \"filter-date-created filter-date-read\"\n    \"filter-includes filter-includes\";\n  grid-template-columns: 1fr 1fr;\n  row-gap: 1.4rem;\n  column-gap: 0.6rem;\n  width: 100%;\n  padding: 0.25rem;\n\n  .filter_includes > div {\n    label {\n      margin-left: 5px;\n      font-size: 0.89rem;\n      color: var(--branded-font-color);\n    }\n  }\n\n  :global(.p-calendar) {\n    width: auto !important;\n  }\n\n  .label {\n    display: block;\n    margin-bottom: 0.3rem;\n  }\n\n  .filter_searchBox {\n    grid-area: filter-searchBox;\n  }\n\n  .filter_eventType {\n    grid-area: filter-eventType;\n  }\n\n  .filter_date_created {\n    grid-area: filter-date-created;\n  }\n\n  .filter_date_read {\n    grid-area: filter-date-read;\n  }\n\n  .filter_includes {\n    grid-area: filter-includes;\n  }\n}\n\n/*Notifications accordion grid: */\n.noteFilterHeaderGridContainer {\n  display: grid;\n  grid-template-areas: \"title button\";\n  width: 100%;\n}\n\n.noteFilterHeader {\n  grid-area: title;\n  text-align: left;\n  position: absolute;\n  top: 35%;\n}\n\n.noteFilterButton {\n  grid-area: button;\n}\n\n.noteMainTabHeader {\n  margin-right: 10px;\n  height: 45px;\n  width: 120px;\n  align-items: center;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.noteMainTabHeaderActive {\n  border-color: var(--branded-purple);\n}\n\n.noteHighImportant {\n  font-size: 11px;\n  margin-left: 10px;\n}\n\n.noteSettingsLayout {\n  width: 100%;\n  height: 100%;\n  margin-bottom: 1rem;\n  border: 1px solid var(--branded-light-purple);\n  border-radius: 20px;\n  position: relative;\n\n  .all_notifications_row {\n    background-color: var(--branded-light-purple);\n  }\n\n  .advance_settings_btn {\n    margin-top: 20px;\n\n    span {\n      font-weight: bold;\n    }\n\n    margin-left: 0.8rem;\n  }\n\n  .purple_bk {\n    background-color: var(--branded-light-purple);\n  }\n\n  .noteSettingsTable {\n    position: relative;\n    height: 100%;\n    width: 100%;\n\n    thead,\n    tbody {\n      display: block;\n      width: 100%;\n    }\n\n    :global(.p-datatable-tbody:not(.p-datatable-frozen-tbody)) {\n      height: 50vh;\n      overflow-y: auto;\n      padding-right: 0.6rem;\n    }\n  }\n\n  .settings_table {\n    height: 100%;\n    width: 100%;\n\n    thead,\n    tbody {\n      display: block;\n      width: 100%;\n    }\n\n    tbody {\n      overflow-y: auto;\n      padding-right: 0.6rem;\n    }\n\n    tbody > tr > td {\n      color: var(--branded-text-color);\n      padding: 0.6rem;\n    }\n\n    tbody > tr > td:first-child {\n      padding-left: 0.8rem;\n    }\n\n    thead > tr > th {\n      border: 1px solid #e5e7eb;\n      border-width: 0 0 1px 0;\n      padding: 0.8rem 0;\n      background-color: transparent;\n      color: var(--branded-text-color);\n\n      font-weight: bold;\n      text-align: left;\n    }\n\n    thead > tr > th:first-child {\n      padding-left: 0.8rem;\n    }\n\n    tbody > tr > td {\n      width: 10vw;\n    }\n\n    thead > tr > th {\n      width: 10vw;\n    }\n\n    tbody > tr > td:first-child,\n    thead > tr > th:first-child {\n      width: 50vw;\n    }\n\n    tbody > tr:first-child > td {\n      padding-left: 0;\n      padding-right: 0;\n    }\n\n    tbody > tr > td:not(:first-child) {\n      padding-left: 0;\n      padding-right: 0;\n    }\n\n    tbody > tr > td:first-child {\n      padding-right: 0;\n    }\n\n    tbody > tr > td {\n      padding-top: 0;\n      padding-bottom: 0;\n    }\n\n    .settings_table_cell {\n      display: flex;\n      align-items: center;\n      height: 60px;\n      border: 1px solid var(--branded-light-purple);\n      border-width: 0 0 1px 0;\n    }\n\n    tbody > tr > td:last-child {\n      .settings_table_cell {\n        padding-right: 0.8rem;\n      }\n    }\n  }\n\n  .settings_table.full_table {\n    tbody {\n      height: fit-content;\n    }\n\n    td:not(:first-child) .settings_table_cell {\n      padding-left: 0.6rem;\n    }\n\n    .isAll {\n      td {\n        padding-top: 0;\n        padding-bottom: 0;\n      }\n\n      td .settings_table_cell {\n        margin-top: 0.6rem;\n        padding-left: 0.6rem;\n      }\n\n      td:first-child .settings_table_cell {\n        padding-left: 0.8rem;\n      }\n    }\n  }\n\n  .settings_table:not(.full_table) {\n    .isAll {\n      td:first-child {\n        padding-left: 0.8rem;\n      }\n\n      td:not(:first-child) .settings_table_cell {\n        padding-left: 0.6rem;\n      }\n    }\n\n    td:not(:first-child) .settings_table_cell {\n      padding-left: 0.6rem;\n    }\n  }\n\n  .noteSettingsCheckedColumn {\n    width: 10vw;\n    padding: 0.6rem !important;\n  }\n\n  :global(.p-datatable .p-datatable-tbody > tr > td) {\n    border: 1px solid var(--branded-light-purple);\n    color: var(--branded-text-color);\n    border-width: 0 0 1px 0;\n    padding: 0.6rem 0;\n    font-size: 0.75rem;\n  }\n\n  :global(.p-datatable .p-datatable-thead > tr > th) {\n    border: 1px solid #e5e7eb;\n    border-width: 0 0 1px 0;\n    padding: 0.5rem;\n    background-color: transparent;\n  }\n\n  :global(.p-datatable .p-datatable-thead > tr > th:first-child),\n  :global(.p-datatable .p-datatable-thead > tr > th:last-child) {\n    padding-left: 0;\n  }\n\n  :global(.p-datatable .p-datatable-thead > tr > th) {\n    width: 10vw;\n  }\n\n  :global(.p-datatable .p-datatable-thead > tr > th:first-child) {\n    width: 36.9vw !important;\n  }\n\n  :global(.p-column-title) {\n    color: var(--branded-text-color);\n    font-size: 0.75rem;\n    font-weight: bold;\n  }\n}\n\n.multiselectFilter:global(.p-multiselect .p-multiselect-label.p-placeholder) {\n  font-size: 0.89rem !important;\n  color: #999999;\n}\n\n.filterTemplateItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.filterTemplateLabel {\n  font-weight: 400;\n  line-height: 16.34px;\n  color: #495057 !important;\n}\n\n.customMessage {\n  :global(.p-message-wrapper) {\n    border-radius: 8px;\n    border: 1px solid #3b82f6;\n    background: rgba(59, 130, 246, 0.2);\n    padding: 0.5rem 0.8rem;\n    font-size: 0.8rem;\n    width: 100%;\n    position: relative;\n    color: #3b82f6;\n\n    i {\n      color: #3b82f6;\n      font-size: 1rem;\n    }\n  }\n\n  :global(.p-message-close) {\n    position: absolute;\n    right: 1.1rem;\n\n    svg {\n      height: 0.8rem;\n    }\n  }\n}\n\n.noteMarkAsUnreadReadBtn {\n  border-radius: 20px;\n  padding-bottom: 10px;\n  padding-right: 14px;\n  background-color: white;\n  border: 1px solid #e7e0f1 !important;\n  color: #495057;\n  font-weight: 400;\n  font-size: 0.82rem;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 0.6rem;\n  cursor: pointer !important;\n  pointer-events: all !important;\n\n  &:hover {\n    background-color: rgba(135, 60, 170, 0.1);\n  }\n}\n\n.noteMarkAsReadBtn {\n  border-radius: 20px;\n  padding-bottom: 10px;\n  padding-right: 14px;\n  background-color: #873caa;\n  border: 1px solid #873caa !important;\n  color: white;\n  font-weight: 400;\n  font-size: 0.82rem;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 0.6rem;\n  cursor: pointer !important;\n  pointer-events: all !important;\n\n  &:hover {\n    background-color: #6d3092;\n  }\n}\n\n/* ---------------------------------- */\n/* Tablet */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .filter_dialog_container {\n    grid-template-areas:\n      \"filter-searchBox filter-searchBox\"\n      \"filter-eventType filter-eventType\"\n      \"filter-date-created filter-date-created\"\n      \"filter-date-read filter-date-read\"\n      \"filter-includes filter-includes\";\n\n    :global(.p-calendar) {\n      width: 100% !important;\n    }\n  }\n\n  .noteBodyActionButtons {\n    display: block;\n  }\n\n  .noteBodyActionButton {\n    margin-left: 20px;\n    margin-bottom: 10px;\n  }\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .noteBodyContainer {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .noteBodyActionButtons {\n    display: block;\n    margin-top: 20px;\n  }\n\n  .noteBodyActionButton {\n    margin-bottom: 10px;\n  }\n\n  .filters {\n    display: flex;\n    flex-wrap: wrap;\n    /* justify-content: space-between; */\n    gap: 1rem;\n  }\n\n  .sort {\n    margin-left: auto;\n  }\n\n  .organization_dropdown {\n    width: 100%;\n  }\n\n  .noteHeaderGridContainer {\n    grid-template-areas:\n      \"unread title-desc\"\n      \". other\"\n      \". system-not\";\n    grid-template-columns: 2rem 1fr;\n    row-gap: 0.5rem;\n  }\n\n  .noteHeaderOther {\n    flex-direction: column;\n    gap: 0.8rem;\n    align-items: flex-start;\n\n    button {\n      width: 100%;\n    }\n  }\n\n  :global(.p-accordion-toggle-icon) {\n    margin-bottom: 1rem !important;\n  }\n\n  :global(.p-accordion-header:not(.p-disabled) a) {\n    align-items: flex-end !important;\n  }\n\n  .noteHeaderGridItemOrg,\n  .noteHeaderGridItemCreation {\n    text-align: left !important;\n  }\n\n  .filter_dialog_container {\n    grid-template-areas:\n      \"filter-searchBox\"\n      \"filter-eventType\"\n      \"filter-date-created\"\n      \"filter-date-read\"\n      \"filter-includes\";\n    grid-template-columns: 1fr;\n\n    :global(.p-calendar) {\n      width: 100% !important;\n    }\n\n    .filter_includes {\n      flex-direction: column;\n      gap: 0.5rem !important;\n      align-items: flex-start !important;\n    }\n  }\n\n  .filter_date_created > div,\n  .filter_date_read > div {\n    flex-direction: column;\n  }\n\n  .noteSettingsLayout {\n    .settings_table.full_table {\n      tbody {\n        height: fit-content;\n      }\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .sort {\n    margin-left: 0px;\n  }\n}\n\n@media (max-width: 460px) {\n  .settings_table {\n    thead > tr > th {\n      font-size: 0.6rem !important;\n    }\n  }\n\n  .filters_button {\n    width: 150px;\n  }\n\n  .allread_button {\n    width: 150px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"muteNotSelected": `NotificationsForm_muteNotSelected__TpQ85`,
	"NavButton": `NotificationsForm_NavButton__E+s9h`,
	"addSpace": `NotificationsForm_addSpace__AlkHc`,
	"addLargeSpace": `NotificationsForm_addLargeSpace__T23eV`,
	"NoteMarkRead": `NotificationsForm_NoteMarkRead__jB2JK`,
	"noteAccordion": `NotificationsForm_noteAccordion__QxaVM`,
	"noteHeaderGridItemCreation": `NotificationsForm_noteHeaderGridItemCreation__sPUuR`,
	"noteHeaderGridItemOrg": `NotificationsForm_noteHeaderGridItemOrg__fdBXS`,
	"noteHeaderGridContainer": `NotificationsForm_noteHeaderGridContainer__g53QW`,
	"unread": `NotificationsForm_unread__LLtXE`,
	"systemNot": `NotificationsForm_systemNot__Xhm1Y`,
	"noteHeaderTitleDesc": `NotificationsForm_noteHeaderTitleDesc__nvb1u`,
	"noteHeaderOther": `NotificationsForm_noteHeaderOther__+p7cn`,
	"noteHeaderGridItemTitle": `NotificationsForm_noteHeaderGridItemTitle__BRXrF`,
	"noteHeaderGridItemDescr": `NotificationsForm_noteHeaderGridItemDescr__uSuKB`,
	"systemNotification": `NotificationsForm_systemNotification__EgNMF`,
	"toggleDescriptionButton": `NotificationsForm_toggleDescriptionButton__5zx3c`,
	"allread_button": `NotificationsForm_allread_button__yxAro`,
	"allread_confirm_container": `NotificationsForm_allread_confirm_container__YShzP`,
	"allread_confirm_yes": `NotificationsForm_allread_confirm_yes__Zmv2A`,
	"allread_confirm_no": `NotificationsForm_allread_confirm_no__NF1iD`,
	"noteBodyContainer": `NotificationsForm_noteBodyContainer__SpmQX`,
	"noteBodyInfo": `NotificationsForm_noteBodyInfo__2xUeH`,
	"noteBodyActionButtons": `NotificationsForm_noteBodyActionButtons__q1Ib6`,
	"noteBodyActionButton": `NotificationsForm_noteBodyActionButton__tyMHt`,
	"label": `NotificationsForm_label__QJl0b`,
	"filter_dialog_container": `NotificationsForm_filter_dialog_container__P0PWg`,
	"filter_includes": `NotificationsForm_filter_includes__dnkoZ`,
	"filter_searchBox": `NotificationsForm_filter_searchBox__dMcAG`,
	"filter_eventType": `NotificationsForm_filter_eventType__bOlvn`,
	"filter_date_created": `NotificationsForm_filter_date_created__V-Cd6`,
	"filter_date_read": `NotificationsForm_filter_date_read__UDFER`,
	"noteFilterHeaderGridContainer": `NotificationsForm_noteFilterHeaderGridContainer__asan8`,
	"noteFilterHeader": `NotificationsForm_noteFilterHeader__KEw2I`,
	"noteFilterButton": `NotificationsForm_noteFilterButton__u8ihZ`,
	"noteMainTabHeader": `NotificationsForm_noteMainTabHeader__U3qWM`,
	"noteMainTabHeaderActive": `NotificationsForm_noteMainTabHeaderActive__+kLq5`,
	"noteHighImportant": `NotificationsForm_noteHighImportant__zbIa1`,
	"noteSettingsLayout": `NotificationsForm_noteSettingsLayout__hsLMj`,
	"all_notifications_row": `NotificationsForm_all_notifications_row__byTeM`,
	"advance_settings_btn": `NotificationsForm_advance_settings_btn__E4Ra5`,
	"purple_bk": `NotificationsForm_purple_bk__mBE+0`,
	"noteSettingsTable": `NotificationsForm_noteSettingsTable__XX4Aa`,
	"settings_table": `NotificationsForm_settings_table__TRog1`,
	"settings_table_cell": `NotificationsForm_settings_table_cell__AHAEw`,
	"full_table": `NotificationsForm_full_table__RUfC2`,
	"isAll": `NotificationsForm_isAll__f10nu`,
	"noteSettingsCheckedColumn": `NotificationsForm_noteSettingsCheckedColumn__4+tVr`,
	"multiselectFilter": `NotificationsForm_multiselectFilter__2tosl`,
	"filterTemplateItem": `NotificationsForm_filterTemplateItem__VdpgH`,
	"filterTemplateLabel": `NotificationsForm_filterTemplateLabel__JxcR-`,
	"customMessage": `NotificationsForm_customMessage__pL8gQ`,
	"noteMarkAsUnreadReadBtn": `NotificationsForm_noteMarkAsUnreadReadBtn__OdC0i`,
	"noteMarkAsReadBtn": `NotificationsForm_noteMarkAsReadBtn__HJMXz`,
	"filters": `NotificationsForm_filters__x8Kll`,
	"sort": `NotificationsForm_sort__VAIb+`,
	"organization_dropdown": `NotificationsForm_organization_dropdown__j6wuH`,
	"filters_button": `NotificationsForm_filters_button__kiX9C`
};
export default ___CSS_LOADER_EXPORT___;
